
<template>
  <!--新增文档-->
  <div>
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="$store.state.long_itemLayout"
  >
    <template slot="appLocation" slot-scope="{formItem}">
      <a-form-item class="row-form-item"
        :label="formItem.label"
        has-feedback
        required
        v-bind="$store.state.long_itemLayout">
        <template v-for="(item, index) of formItem.subList">
          <a-form-item
            :style="{width: '33%'}"
            v-if="item.inputType === 'select'"
            :label="item.label"
            has-feedback
            v-bind="{ wrapperCol: { span: 24 } }"
            :key="index">
            <a-select
              @change="item.handle"
              v-decorator="item.props"
              allowClear
              showSearch
              :filterOption="filterOption"
              :placeholder="item.placeholder">
              <a-select-option v-for="(el, order) of item.options" :key="order" :value="el.value">
                {{el.label}}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            :style="{width: '33%'}"
            v-if="item.inputType === 'input' && item.isAble"
            :label="item.label"
            has-feedback
            v-bind="{ wrapperCol: { span: 24 } }"
            :key="index">
            <a-input v-decorator="item.props" :placeholder="item.placeholder"/>
          </a-form-item>
        </template>
      </a-form-item>
    </template>

    <template slot="docContent" slot-scope="{formItem}">
      <a-form-item
        :label="formItem.label"
        has-feedback
        required
        v-bind="$store.state.long_itemLayout">
        <!-- <div id="editor"></div> -->
        <wangedit ref='wangedit'></wangedit>
      </a-form-item>
    </template>
  </x-addEdit>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { inputSearch } from 'ant-design-vue-admin-x';
import wangedit from '@/components/package/wangedit.vue';
export default {
  mixins: [fetchSelect, inputSearch],
  name: 'addDocument',
  components: { wangedit },
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入标题' },
          { min: 1, max: 20, message: '标题为1-20个字' },
          {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}
        ]
      },
      categoryId: {
        rules: [{ required: true, message: '请选择分类' }]
      }
    };
    return {
      formKey: {
        title: '',
        categoryId: ''
      },
      formList: [
        {
          label: '标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入标题',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '应用位置',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择分类',
          fieldNames: {label: 'label', value: 'value', children: 'children'},
          props: ['categoryId', decoratorOptions.categoryId]
        },
        {
          slot: 'docContent',
          label: '内容',
          inputType: 'textarea',
          options: [],
          placeholder: ''
        }
      ],
      addParam: {
        url: '/article',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/article/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/article/',
        resHandle: this.detailResHandle // this.detailResHandle
      }
    };
  },
  created () {
    this.$get({
      url: '/category/treeselect'
    }).then(({data}) => {
      this.formList[1].options = data;
    });
  },
  mounted () {
    // this.$refs.addEdit.routeQuery = encodeURIComponent(this.$route.query.id);
    // this.getSelect();
  },
  methods: {
    getSelect () {
      this.marketingManageSelect((data) => {
        this.formList[1].options = data.document_type;
      });
    },
    /* 处理选择二次分类 */
    handleCategory (val) {
      let inputEl = this.formList[1].subList[2];
      val === 2 ? inputEl.isAble = true : inputEl.isAble = false;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      this.editorVal = this.$refs.wangedit.html;
      if (this.editorVal && this.editorVal != '<p><br></p>') {
        param = {...param, ...{content: this.editorVal}};
      } else {
        this.$message.error('请输入文档内容');
        return;
      }
      param.articleId = this.$route.query.id;
      param.categoryId = Array.isArray(param.categoryId) ? param.categoryId.join() : '';
      return param;
    },
    detailResHandle (res) {
      if (res.content && res.content !== '<p><br></p>') {
        // this.editor.txt.html(res.content); // 设置editor内容
        // this.editorVal = res.content;
        // this.editor.change();
        this.$refs.wangedit.html = res.content;
      }
      return {};
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
